module.exports = __webpack_public_path__ + "offer-analysis-shop.svg?523917e72eaa95dd675ab87155a1f475";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/offer-analysis-shop.svg
// module id = 301
// module chunks = 2